// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  versonaId: __t.u64().primaryKey().name("versona_id"),
  worldId: __t.u64().name("world_id"),
  archetype: __t.string(),
  homeCityId: __t.u64().name("home_city_id"),
  spawnX: __t.f32().name("spawn_x"),
  spawnZ: __t.f32().name("spawn_z"),
  curX: __t.f32().name("cur_x"),
  curZ: __t.f32().name("cur_z"),
  behaviorTree: __t.string().name("behavior_tree"),
  scheduleJson: __t.string().name("schedule_json"),
  state: __t.string(),
  updatedAt: __t.timestamp().name("updated_at"),
});
